import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'

const DeleteCouponModal = ({ delCoupon, setDelCoupon }) => {
    return (
        <div>
            <Transition.Root show={delCoupon} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setDelCoupon}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm">
                                    <div>
                                        <div className="font-semibold p-[16px_20px] text-base text-gray-900">Delete coupon</div>
                                        <div className='p-[0px_20px] text-[#1a1b25] text-sm'>
                                            <p className=''>Deleting this coupon will not affect discounts for customers who have already redeemed the coupon, but new redemptions of the coupon won't be allowed.</p>
                                            <h3 className='font-medium mt-2'>Are you sure you want to delete this coupon? This can't be undone.</h3>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                                            <button onClick={() => setDelCoupon(false)} className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px] flex items-center gap-2">Cancel</button>
                                            <button className="h-[30px] rounded-[8px] bg-[#df1b41] border-[##df1b41] text-[14px] font-semibold p-[0_8px] flex items-center gap-2 text-white leading-[30px]">Delete coupon</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default DeleteCouponModal